import IconComponent from "@mdi/react";
import { useCallback, useEffect, useRef, useState } from "react";

import { mdiContentCopy } from "@mdi/js";
import { Alert, Popover } from "antd";

import { Tooltip } from "components/base";

import { ActionButton } from "./ActionButton";

const ACKNOWLEDGEMENT_MS = 2000;

export const useCopyAcknowledgement = (): {
  copied: boolean;
  acknowledge: () => void;
} => {
  const [copied, setCopied] = useState(false);
  const timer = useRef<ReturnType<typeof setTimeout>>();

  useEffect(() => () => clearTimeout(timer.current), []);

  const acknowledge = useCallback(() => {
    setCopied(true);
    clearTimeout(timer.current);
    timer.current = setTimeout(() => setCopied(false), ACKNOWLEDGEMENT_MS);
  }, []);

  return { copied, acknowledge };
};

const DEFAULT_ICON_SIZE = 1.2;

interface CopyIconButtonProps {
  tooltip: string;
  successMessage: string;
  copied: boolean;
  iconSize?: number;
  onClick: () => void;
  "data-testid"?: string;
}

export const CopyIconButton = ({
  tooltip,
  successMessage,
  copied,
  iconSize = DEFAULT_ICON_SIZE,
  onClick,
  "data-testid": testId
}: CopyIconButtonProps): JSX.Element => (
  <Tooltip title={tooltip}>
    <Popover
      open={copied}
      trigger="click"
      placement="bottom"
      overlayClassName="overlay-no-padding"
      content={<Alert type="success" message={successMessage} />}>
      <ActionButton
        type="button"
        aria-label={tooltip}
        data-testid={testId}
        onClick={onClick}>
        <IconComponent path={mdiContentCopy} size={iconSize} />
      </ActionButton>
    </Popover>
  </Tooltip>
);
